import { getSurveyStepByUserGroup, getUserType } from './helper'
import {
  type Action,
  type SurveyState,
  SURVEY_NEXT_STEPS,
  SURVEY_PREV_STEPS,
  SURVEY_SET_EXAMINATION,
  SURVEY_SET_GRADE,
  SURVEY_SET_MAJOR,
  SURVEY_SET_CLASSROOM,
  SURVEY_SET_STEPS,
  SURVEY_SET_USER_GROUP,
  SURVEY_SET_UNIVERSITY,
  SURVEY_SET_MIDDLESCHOOL,
  SURVEY_SET_HIGHSCHOOL,
  SURVEY_SET_EXAMINATION_HAS_USER_SEARCH,
  SURVEY_SET_EXAMINATION_CHECKBOX_ITEM,
  SURVEY_SET_SKIP_FIRST_STEP,
  SURVEY_SET_SKIP_LAST_STEP,
  SURVEY_SET_CHECKBOX_IS_UNIVERSITY,
  SURVEY_SET_CHECKED_USER_GROUP,
  SURVEY_SET_YEAR,
  SURVEY_SET_IS_PENDING,
  SURVEY_SET_ON_MODAL,
  SURVEY_SET_LATEST_RESULT,
  SURVEY_SET_START_STEP,
} from './types'
import { toLegacySurveyUserGroup, toV2UserGroup } from './v2SurveyPayload'

export function surveyReducer(state: SurveyState, action: Action): SurveyState {
  switch (action.type) {
    case SURVEY_SET_USER_GROUP:
      return {
        ...state,
        userGroup: action.payload,
        activeStep:
          action.payload === 'none' // UserGroupSelect에서 surveyOnModal이 false일 때, UserGroupSelect 컴포넌트가 step대로 보이기 위해 추가
            ? state.steps.includes('userNickname')
              ? 1
              : 0
            : state.activeStep,
        checkedUserGroup: action.payload === 'none' ? null : state.checkedUserGroup,
        surveyed: {
          userType: action.payload === 'none' ? null : getUserType(action.payload),
          university: null,
          middleschool: null,
          highschool: null,
          major: null,
          grade: null,
          year: null,
          classroom: null,
          examinations:
            action.payload === 'generalCollege' ||
            action.payload === 'general' ||
            action.payload === 'college'
              ? state.surveyed.examinations
              : null,
        },
        hasUserSearch:
          action.payload === 'generalCollege' ||
          action.payload === 'general' ||
          action.payload === 'college'
            ? state.hasUserSearch
            : false,
        checkboxIsUniversity:
          action.payload === 'generalCollege' ||
          action.payload === 'general' ||
          action.payload === 'college'
            ? state.checkboxIsUniversity
            : null,
        isSkipLastStep: !state.surveyOnModal ? false : state.isSkipLastStep,
        surveyResult: {
          ...state.surveyResult,
          userGroup: toV2UserGroup(
            action.payload === null || action.payload === 'none' ? 'college' : action.payload,
          ),
          userGroupGrade: undefined,
        },
      }
    case SURVEY_SET_STEPS:
      return {
        ...state,
        steps: getSurveyStepByUserGroup(
          action.payload,
          state.isSkipFirstStep,
          state.isSkipLastStep,
        ),
      }
    case SURVEY_NEXT_STEPS:
      return {
        ...state,
        activeStep:
          state.activeStep + 1 > state.steps.length - 1 ? state.activeStep : state.activeStep + 1,
      }
    case SURVEY_PREV_STEPS:
      return {
        ...state,
        activeStep: state.activeStep - 1 === -1 ? 0 : state.activeStep - 1,
      }
    case SURVEY_SET_START_STEP:
      return {
        ...state,
        activeStep: state.steps.indexOf(action.payload),
      }
    case SURVEY_SET_SKIP_FIRST_STEP:
      return {
        ...state,
        // skip 이후, activeStep도 1에서 0으로 줄이기 위해 PrevSteps 처럼 수정
        activeStep:
          state.activeStep === 1
            ? state.activeStep - 1 === -1
              ? 0
              : state.activeStep - 1
            : state.activeStep,
        isSkipFirstStep: action.payload,
        steps: getSurveyStepByUserGroup(
          state.userGroup ?? 'college',
          action.payload,
          state.isSkipLastStep,
        ),
      }
    case SURVEY_SET_SKIP_LAST_STEP:
      return {
        ...state,
        isSkipLastStep: action.payload,
        steps: getSurveyStepByUserGroup(
          state.userGroup ?? 'college',
          state.isSkipFirstStep,
          action.payload,
        ),
      }
    case SURVEY_SET_UNIVERSITY:
      return {
        ...state,
        surveyed: {
          ...state.surveyed,
          major: null,
          university: action.payload,
        },
        surveyResult: state.surveyResult,
      }
    case SURVEY_SET_MIDDLESCHOOL:
      return {
        ...state,
        surveyed: {
          ...state.surveyed,
          grade: null,
          classroom: null,
          middleschool: action.payload,
        },
        surveyResult: state.surveyResult,
      }
    case SURVEY_SET_HIGHSCHOOL:
      return {
        ...state,
        surveyed: {
          ...state.surveyed,
          grade: null,
          classroom: null,
          major: null,
          highschool: action.payload,
        },
        surveyResult: state.surveyResult,
      }
    case SURVEY_SET_MAJOR:
      return {
        ...state,
        surveyed: {
          ...state.surveyed,
          major: action.payload,
        },
        surveyResult: state.surveyResult,
      }
    case SURVEY_SET_YEAR:
      return {
        ...state,
        surveyed: {
          ...state.surveyed,
          year: action.payload,
        },
        surveyResult: state.surveyResult,
      }
    case SURVEY_SET_GRADE:
      return {
        ...state,
        surveyed: {
          ...state.surveyed,
          grade: action.payload,
        },
        surveyResult: {
          ...state.surveyResult,
          userGroupGrade: action.payload[0].grade,
        },
      }
    case SURVEY_SET_CLASSROOM:
      return {
        ...state,
        surveyed: {
          ...state.surveyed,
          classroom: action.payload,
        },
        surveyResult: state.surveyResult,
      }
    case SURVEY_SET_EXAMINATION:
      return {
        ...state,
        surveyed: {
          ...state.surveyed,
          examinations: action.payload,
        },
        surveyResult: {
          ...state.surveyResult,
          examKeywordIds: action.payload
            .filter((item) => item.code !== 'none')
            .map((item) => Number(item.id))
            .filter((id) => !Number.isNaN(id)),
        },
      }
    case SURVEY_SET_CHECKED_USER_GROUP:
      return {
        ...state,
        checkedUserGroup: action.payload,
      }
    case SURVEY_SET_EXAMINATION_HAS_USER_SEARCH:
      return {
        ...state,
        hasUserSearch: action.payload,
      }
    case SURVEY_SET_EXAMINATION_CHECKBOX_ITEM:
      return {
        ...state,
        checkboxExaminations: action.payload,
      }
    case SURVEY_SET_CHECKBOX_IS_UNIVERSITY:
      return {
        ...state,
        checkboxIsUniversity: action.payload,
      }
    case SURVEY_SET_IS_PENDING:
      return {
        ...state,
        surveyIsPending: action.payload,
      }
    case SURVEY_SET_ON_MODAL:
      return {
        ...state,
        activeStep: action.payload ? state.activeStep : 0,
        latestResult: action.payload ? state.latestResult : null,
        surveyOnModal: action.payload,
      }
    case SURVEY_SET_LATEST_RESULT:
      return {
        ...state,
        latestResult: action.payload,
        userGroup: toLegacySurveyUserGroup(action.payload.userGroup),
        checkedUserGroup: toLegacySurveyUserGroup(action.payload.userGroup),
        surveyed: {
          ...state.surveyed,
          userType:
            action.payload.userGroup === null
              ? null
              : getUserType(toLegacySurveyUserGroup(action.payload.userGroup)),
          examinations:
            action.payload.examKeywords?.map((keyword) => ({
              id: keyword.id,
              code: `${keyword.id}`,
              name: keyword.name,
              type: '',
              keyWords: '',
              manageHostName: '',
            })) ?? null,
        },
        surveyResult: {
          examKeywordIds: action.payload.examKeywords?.map((keyword) => keyword.id) ?? [],
          examCustomNames: action.payload.examCustomNames ?? [],
          userGroup: action.payload.userGroup ?? 'university',
          ...(action.payload.userGroupGrade === null
            ? {}
            : { userGroupGrade: action.payload.userGroupGrade }),
        },
      }
    default:
      throw Error('Not Exist Action In SurveyReducer')
  }
}
